import {defineStore} from 'pinia'

export const useLoadingBarStore = defineStore('loadingBar', {
    state: () => ({
        isLoading: false,
        progress: 0
    }),
    actions: {
        start() {
            this.isLoading = true
            this.progress = 0
            
            // Симулируем прогресс
            const interval = setInterval(() => {
                if (this.progress < 90) {
                    this.progress += Math.random() * 10
                } else {
                    clearInterval(interval)
                }
            }, 200)
        },
        finish() {
            this.progress = 100
            setTimeout(() => {
                this.isLoading = false
                this.progress = 0
            }, 300)
        },
        reset() {
            this.isLoading = false
            this.progress = 0
        }
    }
})
